<template>
  <screen v-show="show" :screen-info="$t('footscan.take_off')" @skip="$emit('skip')">
    <img src="../../assets/FootScan/take-off-shoes.svg" :alt="$t('footscan.take_off')" />
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';
import Screen from '../common/Screen.vue';

export default {
  name: 'TakeOff',
  mixins: [autoNext],
  components: {
    Screen,
  },
  data: () => ({
    playThroughGap: 3,
    audioKey: 'foot_take_off',
  }),
};
</script>

<style scoped></style>
